<motif-pagination role="navigation" class="grid-container__pagination">
  <app-pagination-select
    [label]="'common.pageShow' | translate"
    [selectedOption]="currentPageSize()"
    [options]="pageSizeOptions()"
    (selectionChange)="onPageSizeChange($event)">
  </app-pagination-select>
  <span class="pagination__number">{{ 'common.numberOfEntries' | translate: { value1: numberOfRows() } }}</span>

  @if (showFirstButtons()) {
    <button
      class="first-page-button"
      motifIconButton
      [size]="buttonSize.SMALL"
      aria-label="Go to first page"
      (click)="goToFirstPage()">
      <motif-icon [iconFunction]="IconoirFastArrowLeft"></motif-icon>
    </button>

    <button
      class="prev-page-button"
      motifIconButton
      [size]="buttonSize.SMALL"
      aria-label="Go to previous page"
      (click)="goToPreviousPage()">
      <motif-icon [iconFunction]="IconoirNavArrowLeft"></motif-icon>
    </button>
  }

  <motif-count role="status" [currentPage]="currentPage()" [numberOfPages]="numberOfPages()"></motif-count>

  @if (showLastButtons()) {
    <button
      class="next-page-button"
      motifIconButton
      [size]="buttonSize.SMALL"
      aria-label="Go to next page"
      (click)="goToNextPage()">
      <motif-icon [iconFunction]="IconoirNavArrowRight"></motif-icon>
    </button>

    <button
      class="last-page-button"
      motifIconButton
      [size]="buttonSize.SMALL"
      aria-label="Go to last page"
      (click)="goToLastPage()">
      <motif-icon [iconFunction]="IconoirFastArrowRight"></motif-icon>
    </button>
  }
</motif-pagination>
